goog.provide('el8.appchart.metrics');

goog.require('el8.ptdata.base');
goog.require('el8.util.perfMark');

el8.appchart.metrics = (function() {
    var that = {};

    var initialLoadSections = {};

    var _reportChartLoadDone = function() {
        if (window.performance && window.performance.now) {
            // https://developer.mozilla.org/en-US/docs/Web/API/Performance/now
            // performance.now() return time in millis since the page started loaded ("navigationStart")
            var chartLoadMillis = window.performance.now();
            // We've seen some really crazy numbers (like thousands of seconds), which screws up the graphs.
            // Let's just call this number "the average of the bottom 99%" or something and throw those out...
            // We'll allow up to two minutes.
            if (chartLoadMillis > 120*1000) { return; }
            el8.util.perfMark.mark('patient-chart-load');
        }
    };

    var _chartSectionDone = function(chartSectionName) {
        if (initialLoadSections[chartSectionName] !== undefined) {
            delete initialLoadSections[chartSectionName];
            if (Object.keys(initialLoadSections).length === 0) {
                _reportChartLoadDone();
            }
        }
    };

    that.getChartLoadCallback = function(chartSectionName) {
        if (initialLoadSections[chartSectionName] !== undefined) {
            UIM && UIM.logError("Duplicate chartSectionName '" + chartSectionName + "' when requesting initial load callback");
        }
        else {
            initialLoadSections[chartSectionName] = 1; // Some random value; only existence of key matters
        }

        return function() { _chartSectionDone(chartSectionName); };
    };

    that.skipChartSection = function(chartSectionName) {
        _chartSectionDone(chartSectionName);
    };

    return that;
})();
